export enum ReelReturnStatus {
  Cancelled = 'cancelled',
  Draft = 'draft',
  Generated = 'generated',
  Received = 'received',
  Unsubmitted = 'unsubmitted',
}
